import { render, staticRenderFns } from "./MarketingProjects.vue?vue&type=template&id=5ea0413e&scoped=true&"
import script from "./MarketingProjects.vue?vue&type=script&lang=js&"
export * from "./MarketingProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea0413e",
  null
  
)

export default component.exports